import useUpdateSessionTop from '@/hooks/sessions/use-update-session-top';
import type { ConversationType } from '@/models/conversations/conversation-session';
import { useConversationSessionStore } from '@/stores/conversation-session';
import { useMessageStore } from '@/stores/message';
import { generateSessionKey } from '@/utils/session';

export default function useClearSession(type: ConversationType, id: Nullable<number>) {
  const mutation = useUpdateSessionTop(type, id);

  const clearSession = async (shouldHide = true) => {
    if (!id) throw 'BAD_SESSION_ID';
    const key = generateSessionKey(type, id);

    await useMessageStore.getState().hideAll(type, id);
    if (shouldHide) {
      useConversationSessionStore.getState().hideSession(key);
      await mutation.mutateAsync(false);
    }
  };

  return {
    clearSession,
    ...mutation,
  };
}
